
import Vue from 'vue';
import { ModalActions, ModalTitle, Button } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    ModalTitle,
    ModalActions,
    Button,
  },
  props: {
    isTrial: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageSrc(): string {
      return this.isTrial
        ? 'https://classrooms-assets.s3.sa-east-1.amazonaws.com/post-grad/planejamento-trial.png'
        : 'https://paperx-dex-assets.s3.sa-east-1.amazonaws.com/images/1647286529753-3xqnBPwDrW.png';
    },
    title(): string {
      return this.isTrial
        ? this.$t('postgradStudyPlanning.defaultStudyPlanningModal.trial.header').toString()
        : this.$t(
            'postgradStudyPlanning.defaultStudyPlanningModal.regularContract.header',
          ).toString();
    },
  },
  methods: {
    createStudyPlanning(): void {
      this.$emit('createStudyPlanning');
    },
  },
});
